import { Descriptions, Spin, Divider, Table, Button, Space } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { useParams } from "react-router-dom";
import { useRequest } from "ahooks";
import { department as departmentService } from "@/services";
import { useAuthContext } from "@/components/auth/AuthProvider";
import styles from "./index.module.less";
function DepartmentDetail() {
  const params = useParams();
  const auth = useAuthContext();
  const { data, loading } = useRequest(
    () => departmentService.detail(params.departmentId, auth.token),
    {
      ready: params.departmentId,
      refreshDeps: [params.departmentId, auth.token],
    }
  );
  const columns = [
    {
      title: "用户名",
      dataIndex: "username",
    },
    {
      title: "创建时间",
      dataIndex: "date_joined",
    },
    {
      title: "最后登录时间",
      dataIndex: "last_login",
    },
    {
      title: "操作",
      key: "operate",
      width: 120,
      render: (record) => {
        return (
          <Space>
            <Button icon={<EditOutlined />} size="small" />
            <Button icon={<DeleteOutlined />} size="small" />
          </Space>
        );
      },
    },
  ];

  return (
    <div className={styles.departmentDetail}>
      {loading ? (
        <Spin />
      ) : (
        <div className="department-detail-content">
          <Descriptions title="基本信息" column={2}>
            <Descriptions.Item label="名称">{data?.name}</Descriptions.Item>
            <Descriptions.Item label="简称">
              {data?.short_name}
            </Descriptions.Item>
            <Descriptions.Item label="类型">
              {data?.types.map((t) => t.name).join(", ")}
            </Descriptions.Item>
            <Descriptions.Item label="办公电话">
              {data?.office_phone}
            </Descriptions.Item>
          </Descriptions>
          <Divider />
          <Descriptions title="负责人信息">
            <Descriptions.Item label="姓名">
              {data?.director_name}
            </Descriptions.Item>
            <Descriptions.Item label="职务">
              {data?.director_job}
            </Descriptions.Item>
            <Descriptions.Item label="电话">
              {data?.director_phone}
            </Descriptions.Item>
          </Descriptions>
          <Divider />
          <Table
            rowKey="id"
            size="small"
            columns={columns}
            dataSource={data?.users}
            loading={loading}
            pagination={false}
          />
        </div>
      )}
    </div>
  );
}

export default DepartmentDetail;
